import { useStopSourcing } from "@vidario/api-client";
import { ConfirmDialog, useToast } from "@vidario/ui";
import { type ReactElement } from "react";

export interface StopSearchDialogProps {
  jobId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** The admin's stop of a running search (#88), confirmed first. The search
 * keeps what it found; a new one is a separate restart. */
export function StopSearchDialog({
  jobId,
  open,
  onOpenChange,
}: StopSearchDialogProps): ReactElement {
  const toast = useToast();
  const stop = useStopSourcing();

  const handleConfirm = (): void => {
    stop.mutate(jobId, {
      onSuccess: () => {
        onOpenChange(false);
        toast.push({
          kind: "success",
          title: "Suche wird gestoppt",
          message: "Bereits gefundene Kandidaten bleiben erhalten.",
        });
      },
      onError: (err) =>
        toast.push({ kind: "error", title: "Stoppen fehlgeschlagen", message: err.message }),
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Kandidatensuche stoppen?"
      confirmLabel="Suche stoppen"
      // A reflex Enter keeps everything (#186).
      initialFocus="cancel"
      tone="destructive"
      loading={stop.isPending}
      onConfirm={handleConfirm}
    >
      <p>
        Die laufende Suche wird gestoppt. Bereits gefundene Kandidaten bleiben erhalten; eine neue
        Suche startest du danach mit „Kandidatensuche neu starten“.
      </p>
    </ConfirmDialog>
  );
}
